import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHouseOfferSearchParams } from '../../house-offer/context/HouseOfferSearchParamsContext';
import { useOffer } from '../../../context/OfferProvider';
import CustomContainer from '../../../components/CustomContainer';
import CustomerSection from './CustomerSection';
import PaymentSection from './PaymentSection';
import AdditionalInformationSection from './AdditionalInformationSection';
import OfferSummary from '../../house-offer/result/OfferSummary';
import SearchHouse from '../../../components/lakeview/searchHouse/SearchHouse';
import { Col, Row } from 'react-bootstrap';
import { useCheckoutState } from './hooks/useCheckoutState';
import ConsentSection from './ConsentSection';
import ReservationTimeline from '../../../components/lakeview/ReservationTimeline';

const CheckoutPage = () => {
  const { id } = useParams();
  const { searchParams } = useHouseOfferSearchParams();

  const {
    offerResult,
    setOfferResult,
    setCanModifyPayments,
    manualDiscounts,
    manualAdditionalPayments,
    offerLoaded,
    offerAvailableToSell,
  } = useOffer();

  useEffect(() => {
    setCanModifyPayments(true);
  }, []);

  const {
    customer,
    setCustomer,
    paymentSelections,
    setPaymentSelections,
    paymentOnBookingPercentage,
    securityDepositAmount,
    setPaymentOnBookingPercentage,
    setSecurityDepositAmount,
    additionalInformation,
    setAdditionalInformation,
    formKey,
    setFormKey,
    setNewCustomerReady,
    setPaymentReady,
    editMode,
    setEditMode,
    reserveHouse,
    isReadyToReserve,
    isLoading,
    consents,
    setConsents,
  } = useCheckoutState(null, id);

  if (!searchParams || isLoading) return null;

  return (
    <CustomContainer title={'Rezerwacja domku'}>
      <Col md={8}>
        <Row>
          {!!offerAvailableToSell && (
            <>
              <CustomerSection
                customer={customer}
                setCustomer={setCustomer}
                formKey={formKey}
                setFormKey={setFormKey}
                setNewCustomerReady={setNewCustomerReady}
              />
              <ConsentSection
                changeAccepted={() => {
                  const updated = {};
                  Object.keys(consents).forEach((key) => {
                    updated[key] = !consents[key];
                  });
                  setConsents(updated);
                }}
                accepted={Object.values(consents).every(Boolean)}
              />

              <PaymentSection
                offerResult={offerResult}
                paymentSelections={paymentSelections}
                setPaymentSelections={setPaymentSelections}
                paymentOnBookingPercentage={paymentOnBookingPercentage}
                securityDepositAmount={securityDepositAmount}
                setPaymentReady={setPaymentReady}
                updatePaymentOnBookingPercentage={(data) => {
                  setPaymentOnBookingPercentage(
                    data?.paymentOnBookingPercentage,
                  );
                }}
                updateSecurityDepositAmount={(data) => {
                  setSecurityDepositAmount(
                    data?.securityDepositAmount,
                  );
                }}
              />
              <AdditionalInformationSection
                additionalInformation={additionalInformation}
                updateAdditionalInformation={setAdditionalInformation}
              />
              <ReservationTimeline
                cancellationRules={offerResult?.result?.cancellationRules}
                arrivalDate={offerResult?.result?.startDate}
                departureDate={offerResult?.result?.endDate}
                currentRefundStatus={offerResult?.result?.currentRefundStatus}
              />
            </>
          )}
        </Row>
      </Col>

      <OfferSummary
        key={JSON.stringify(offerResult?.result)}
        width={4}
        onClickNext={
          isReadyToReserve() ? () => reserveHouse(searchParams) : undefined
        }
        offer={offerResult?.result}
        nextLabel="Rezerwuj"
        show={offerLoaded && !editMode}
      />

      <SearchHouse
        key={id}
        houseId={id}
        setResult={setOfferResult}
        onReset={() => setEditMode(false)}
        onSearchHouse={() => setEditMode(false)}
        manualDiscounts={manualDiscounts}
        manualAdditionalPayments={manualAdditionalPayments}
        paymentOnBookingPercentage={paymentOnBookingPercentage}
        securityDepositAmount={securityDepositAmount}
        paymentModel={paymentSelections?.paymentModel}
        show={editMode}
      />
    </CustomContainer>
  );
};

export default CheckoutPage;
